import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Row, Col, Button } from 'react-bootstrap';
import { SimpleCenteredModal } from '../../../components';
import OvertimeCompensationDatatable from './OvertimeCompensationDatatable';
import { OvertimeSummaryCard, OvertimeEquivalenceCard } from './OvertimeCompensationCards';
import OvertimeCompensationNew from './OvertimeCompensationNew';
import columns, { setColumnsContext } from './Columns';
import useOvertimeCompensationData from './useOvertimeCompensationData';
import { sendAlert } from '../../../actions/utils';

const OvertimeCompensationIndex = ({ currentEmployee, moreData, setMoreData }) => {
  const [modalBody, setModalBody] = useState('');
  const [modalShow, setModalShow] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const dispatch = useDispatch();

  const {
    overtimeData,
    loading,
    totalRemainingBalance,
    overtimeEquivalence,
    fetchDashboardCards: fetchDashboardCardsOriginal
  } = useOvertimeCompensationData(currentEmployee);

  const fetchDashboardCards = useCallback(() => {
    fetchDashboardCardsOriginal();
  }, [fetchDashboardCardsOriginal]);

  useEffect(() => {
    fetchDashboardCards();
  }, [moreData, fetchDashboardCards]);

  const handleSuccessAction = message => {
    dispatch(sendAlert({ kind: 'success', message }));
    setMoreData(!moreData);
    setModalShow(false);
  };

  const handleModalClose = () => setModalShow(false);

  const handleOpenModal = () => {
    setModalTitle('Solicitar Días por Horas Extras');
    setModalBody(
      <OvertimeCompensationNew
        onSuccess={handleSuccessAction}
        employeeId={currentEmployee}
        availableDays={overtimeEquivalence}
      />
    );
    setModalShow(true);
  };

  useEffect(() => {
    setColumnsContext(true, currentEmployee);
  }, [currentEmployee]);

  return (
    <Row className="mt-2 mb-3">
      <Col>
        <Row>
          <Col md={{ span: 3, offset: 9 }}>
            <Button
              variant="primary"
              className="d-none d-md-block mt-0"
              block
              onClick={handleOpenModal}
              disabled={!overtimeData?.data?.[0]?.dailyWorkingHours}
            >
              Nuevo
            </Button>
          </Col>
        </Row>

        <Row className="mt-3 overtime-container align-items-start">
          <Col md={8}>
            {!loading && overtimeData?.data && (
              <OvertimeSummaryCard overtimeData={overtimeData.data} totalRemainingBalance={totalRemainingBalance} />
            )}
          </Col>
          <Col md={4} className="d-flex flex-column">
            {!loading && overtimeData?.data && (
              <OvertimeEquivalenceCard overtimeData={overtimeData.data} overtimeEquivalence={overtimeEquivalence} />
            )}
          </Col>
        </Row>

        <OvertimeCompensationDatatable
          columns={columns}
          moreData={moreData}
          setMoreData={setMoreData}
          currentEmployee={currentEmployee}
        />

        <SimpleCenteredModal title={modalTitle} size="lg" body={modalBody} show={modalShow} onHide={handleModalClose} />
      </Col>
    </Row>
  );
};

export default OvertimeCompensationIndex;
